import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminFichaComponent } from './ficha/admin-ficha/admin-ficha.component';
import { NotFoundComponent } from './page/not-found/not-found.component';


const routes: Routes = [
  {
    path: "",
    component: AdminFichaComponent
  },
  {
    path: "**",
    pathMatch: "full",
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
